import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailVerifyRoute: InvariantJiraRoute = {
	name: 'global-settings-system-mail-verify',
	path: '/secure/admin/VerifyPopServerConnection([!%]?[\\w]*).jspa',
};
